export enum PaymentPeriod {
    DAILY = 'DAILY', MONTHLY = 'MONTHLY', YEARLY = 'YEARLY'
}
export enum Package {
    FREE = 'FREE', BASIC = 'BASIC', MEDIUM = 'MEDIUM', PREMIUM = 'PREMIUM', EXPIRED = 'EXPIRED'
}